// @ts-nocheck
/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import React, { useState } from 'react'
import { createStructuredSelector } from 'reselect'
import _ from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { useTranslation } from 'react-i18next'
import { Collapse } from 'reactstrap'
import TimeAgo from 'react-timeago'
import BellIcon from 'mdi-react/BellIcon'

import { getNotifications } from 'Redux/selectors/notifications'
import { getIsArtist } from 'Redux/selectors/auth'
import {
  markArtistNotificationsAsRead,
  markCuratorNotificationsAsRead,
} from 'Redux/actions/notificationsActions'
import ava from 'Shared/img/ava.png'

import CustomScrollDiv from '../../../Shared/custom/CustomScrollDiv'

interface NotificationInput {
  isNew: boolean
}

const TopbarMail = ({
  notifications,
  isArtist,
  markArtistNotificationsAsRead,
  markCuratorNotificationsAsRead,
}) => {
  const { t } = useTranslation()

  const [collapse, setCollapse] = useState(false)

  const toggle = () => {
    setCollapse(!collapse)
    if (isArtist && notifications.some(({ isNew }) => isNew)) {
      markArtistNotificationsAsRead()
    } else if (
      !isArtist &&
      notifications.some(({ isNew }: NotificationInput) => isNew)
    ) {
      markCuratorNotificationsAsRead()
    }
  }

  const renderNotification = ({
    type_id: type,
    extra_score,
    artist_name,
    track_name,
    created_at,
    playlist_name,
  }) => {
    switch (type) {
      case 1:
        return (
          <div className="topbar__collapse-message-curator">
            <span className="topbar__collapse-notify-header-message">
              {t('notification.youReceived')}&nbsp;
              {extra_score > 0 ? (
                <span className="accent">+{extra_score}</span>
              ) : (
                <span className="accent">0</span>
              )}
              &nbsp;{t('notification.extraPoints')}
              &nbsp;<span className="accent">{playlist_name}</span>
            </span>
            <span className="topbar__collapse-name-curator">{track_name} </span>
            {t('notification.stayedInPlaylist')}
            <p className="topbar__collapse-date-curator">
              <TimeAgo date={created_at} />
            </p>
          </div>
        )
      case 2:
        return (
          <div className="topbar__collapse-message-curator">
            <span className="topbar__collapse-notify-header-message">
              {t('notification.youReceived')}&nbsp;
              {extra_score > 0 ? (
                <span className="accent">+{extra_score}</span>
              ) : (
                <span className="accent">0</span>
              )}
              &nbsp;{t('notification.extraPoints')}
              &nbsp;<span className="accent">{playlist_name}</span>
            </span>
            <span className="topbar__collapse-name-curator">{track_name} </span>
            {t('notification.stayedOnTheTop')}
            <p className="topbar__collapse-date-curator">
              <TimeAgo date={created_at} />
            </p>
          </div>
        )
      case 3:
        return (
          <div className="topbar__collapse-message-curator">
            <span className="topbar__collapse-notify-header-message">
              {t('notification.youReceived')}&nbsp;
              {extra_score > 0 ? (
                <span className="accent">+{extra_score}</span>
              ) : (
                <span className="accent">0</span>
              )}
              &nbsp;{t('notification.extraPoints')}
              &nbsp;<span className="accent">{playlist_name}</span>
            </span>
            <span className="topbar__collapse-name-curator">
              {artist_name}{' '}
            </span>
            {t('notification.positiveReview')}
            <p className="topbar__collapse-date-curator">
              <TimeAgo date={created_at} />
            </p>
          </div>
        )
      case 4:
        return (
          <div className="topbar__collapse-message-curator">
            <span className="topbar__collapse-notify-header-message">
              {t('notification.youLost')}&nbsp;
              <span style={{ color: 'rgb(255, 72, 97' }}>{extra_score}</span>
              &nbsp;{t('notification.extraPoints')}
              &nbsp;<span className="accent">{playlist_name}</span>
            </span>
            <span className="topbar__collapse-name-curator">
              {artist_name}{' '}
            </span>
            {t('notification.nefativeReview')}
            <p className="topbar__collapse-date-curator">
              <TimeAgo date={created_at} />
            </p>
          </div>
        )
      case 5:
        return (
          <div className="topbar__collapse-message-curator">
            <span className="topbar__collapse-notify-header-message">
              {t('notification.youReceived')}&nbsp;
              <span className="accent">+{extra_score}</span>
              &nbsp;{t('notification.extraPoints')}
              &nbsp;<span className="accent">{playlist_name}</span>
            </span>
            {t('notification.skipReview')}
            <p className="topbar__collapse-date-curator">
              <TimeAgo date={created_at} />
            </p>
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className="topbar__collapse-btn">
      <button
        className="topbar__btn topbar__btn--mail topbar__btn--new"
        type="button"
        onClick={toggle}
      >
        <BellIcon />
        {notifications.some(({ isNew }) => isNew) && (
          <div className="topbar__btn-new-label">
            <div />
          </div>
        )}
      </button>
      {collapse && (
        <button className="topbar__back" type="button" onClick={toggle} />
      )}
      {collapse && (
        <Collapse className="topbar__collapse-content" isOpen={collapse}>
          <div className="topbar__collapse-content-wrapper">
            <div className="topbar__collapse-title-wrap">
              <p className="topbar__collapse-title">
                {t('notification.notifications')}
              </p>
            </div>
            {!_.isEmpty(notifications) ? (
              <>
                {isArtist ? (
                  <CustomScrollDiv length={notifications.length}>
                    {notifications.map(
                      ({
                        id,
                        date,
                        Playlist: {
                          playlist_url,
                          playlist_name,
                          Curator: { first_name, last_name, user_photo_url },
                        },
                      }) => (
                        <div className="topbar__collapse-item" key={id}>
                          <div className="topbar__collapse-item-img">
                            <img
                              src={!user_photo_url ? ava : user_photo_url}
                              alt="avatar"
                              //  eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onError={(e: any) => {
                                e.target.onerror = null
                                e.target.src = ava
                              }}
                            />
                          </div>
                          <div className="topbar__collapse-message">
                            <div className="topbar__collapse-notify-header-message">
                              {t('notification.trackAdded')}&nbsp;
                              <a
                                href={`https://open.spotify.com/playlist/${playlist_url.slice(
                                  -22
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                &nbsp;{playlist_name}&nbsp;
                              </a>
                              <p className="topbar__collapse-name">
                                <span>{t('notification.by')} </span>
                                <span>
                                  {first_name} {last_name}
                                </span>
                              </p>
                              <p className="topbar__collapse-date">
                                <TimeAgo date={date} />
                              </p>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </CustomScrollDiv>
                ) : (
                  <CustomScrollDiv length={notifications.length}>
                    {notifications.map(item => (
                      <div
                        className="topbar__collapse-item-curator"
                        key={item.id}
                      >
                        <div className="topbar__collapse-item-img-curator">
                          <img
                            src={ava}
                            alt="ava"
                            //  eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onError={(e: any) => {
                              e.target.onerror = null
                              e.target.src = ava
                            }}
                          />
                        </div>
                        {renderNotification(item)}
                      </div>
                    ))}
                  </CustomScrollDiv>
                )}
              </>
            ) : (
              <div className="topbar__collapse-item-empty">
                <p className="topbar__collapse-message">
                  <span className="topbar__collapse-notify-header-message-empty">
                    {t('notification.empty')}
                  </span>
                </p>
              </div>
            )}
          </div>
        </Collapse>
      )}
    </div>
  )
}

const selector = createStructuredSelector({
  notifications: getNotifications,
  isArtist: getIsArtist,
})

const actions = {
  markArtistNotificationsAsRead,
  markCuratorNotificationsAsRead,
}

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
export default compose<any, any>(connect(selector, actions))(TopbarMail)
